export function getOrderItemPresentation(orderStatus, isRefunded) {
  const isDraft = orderStatus === "Draft";

  return {
    isDraft,
    rowClassName: isDraft ? "order-row order-row--draft" : "order-row",
    statusLabel: isRefunded
      ? "Refunded"
      : isDraft
      ? "Draft — not submitted"
      : orderStatus,
  };
}

// MAIN-812: statuses in which an order may still be edited.
//
// "Approved" was previously missing here, so as soon as the restaurant approved
// an order the Edit action vanished from the 3-dot menu — even for a delivery a
// week away, because this status check runs before any date/window check. The
// order-detail page and the API both allow editing an approved order (the API
// applies no status restriction at all: admins are always allowed, customers are
// gated by ownership plus the 24h window), so the list menu was the odd one out.
//
// Cancelled/Completed/Draft remain non-editable, and the caterer role still gets
// no Edit action. The customer's 24h edit window is enforced separately by
// getCustomerOrderActionWindow and, authoritatively, by the API.
export const EDITABLE_ORDER_STATUSES = [
  "New",
  "Scheduled",
  "Pending",
  "Approved",
];

export function canEditOrder(orderStatus, userType) {
  if (userType === "Caterer") {
    return false;
  }

  return EDITABLE_ORDER_STATUSES.includes(orderStatus);
}

// MAIN-812: a customer's Edit routed to `/caterers/${catererSlug}?edit=true`.
// Some orders have no catererSlug, so the URL became "/caterers/null" and the
// customer landed on an empty caterer page with no menu — Edit appeared to work
// but could never be completed. Fall back to the caterer id (the details page
// and the API both resolve either), and refuse to navigate when neither exists
// so the caller can show a message instead of a blank page.
export const MISSING_CATERER_EDIT_MESSAGE =
  "We can't open this order for editing right now. Please call or text us at (646) 535-4875 and we'll update it for you.";

export function resolveCustomerEditRoute(order) {
  const slug = order?.catererSlug;
  if (slug) {
    return { route: `/caterers/${slug}?edit=true`, error: null };
  }

  const catererId = order?.catererId;
  if (catererId) {
    return { route: `/caterers/${catererId}?edit=true`, error: null };
  }

  return { route: null, error: MISSING_CATERER_EDIT_MESSAGE };
}

export function canDeleteOrder(orderStatus, userType) {
  const isAdminDeletable =
    userType === "Admin" && orderStatus !== "Completed";
  const isCustomerDraft =
    userType === "Customer" && orderStatus === "Draft";

  return isAdminDeletable || isCustomerDraft;
}
